<template>
  <div class="container">
    <div class="header">
      <marquee-text :text="channelName" :duration="120"></marquee-text>
      <div class="meeting-details-container">
        <svg class="info-icon" viewBox="0 0 24 24" @click="toggleMeetingDetails">
          <path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
        </svg>
        <div class="meeting-details" v-if="showMeetingDetails">
          <div class="title">Meeting Link</div> 
          <div style="display:flex; align-items :center">
            <div class="selectable">{{meetingURL}}</div>
            <svg class="copy-icon" viewBox="0 0 24 24" :data-clipboard-text="meetingURL" @click="copiedMeeting = true">
              <path fill="currentColor" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
            </svg>
            <div class="copyIndicator" :class="{ visible: copiedMeeting }">Copied!</div>
          </div> 
          <div class="title">Extension</div> 
          <div style="display:flex; align-items :center">
            <div class="selectable">{{extension}}</div>
            <svg class="copy-icon" viewBox="0 0 24 24" :data-clipboard-text="extension" @click="copiedExtension = true">
              <path fill="currentColor" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
            </svg>
            <div class="copyIndicator" :class="{ visible: copiedExtension }">Copied!</div>
          </div>
        </div>
      </div>
      <div class="username">{{ userName }}</div>
    </div>
    <div class="content" ref="outer">
      <div v-show="loading" class="loading">
        Loading Whiteboard
      </div>
      <div v-show="!loading">
        <object-editor :scale="scale"></object-editor>
        <div class="transform-container" :style="style">
          <canvas
                  width="2560" height="1440"
                  id="annotation-canvas"
                  ref="annotationCanvas"
          ></canvas>
        </div>
        <div class="participant">
          <div class="participant-button" @click="showParticipants=!showParticipants">
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M16 17V19H2V17S2 13 9 13 16 17 16 17M12.5 7.5A3.5 3.5 0 1 0 9 11A3.5 3.5 0 0 0 12.5 7.5M15.94 13A5.32 5.32 0 0 1 18 17V19H22V17S22 13.37 15.94 13M15 4A3.39 3.39 0 0 0 13.07 4.59A5 5 0 0 1 13.07 10.41A3.39 3.39 0 0 0 15 11A3.5 3.5 0 0 0 15 4Z" />
            </svg>
            <div>{{users.length}}</div>
          </div>
          <div class="participant-notification" v-if="userAlert">
            {{ userAlert }}
          </div>
        </div>
        <div class="participant-list" v-if="showParticipants">
          <ul>
            <li v-for="user in users" :key="user.user_id"><div :style="{backgroundColor: user.laser_color}"></div><div class="participant-username">{{user.user_name}}</div></li>
          </ul>
        </div>
        <lbo-annotation-controls></lbo-annotation-controls>
      </div>
    </div>
    <div class="footer">
      <svg class="info-icon id-trigger" viewBox="0 0 24 24" @click="showMeetingIds = !showMeetingIds">
        <path fill="#ddd" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
      </svg>
      <div class="meeting-ids selectable" v-show="showMeetingIds">
        <div>m: {{meetingId}}</div>
        <div>u: {{userId}}</div>
      </div>
      <img src="@/assets/Lifesize-Kaptivo.png" style="height:100%">
      <div class="version selectable">V{{version}}</div>
    </div>
  </div>
</template>

<script type="text/babel">
  // TODO: encapsulate transformMatrix handling logic in Whiteboard module
  const { getWhiteboard } = require('@/whiteboard')
  import ClipboardJS from 'clipboard'
  // import lboAnnotationControls from './AnnotationControls.vue';

  import lboAnnotationControls from '@/ui/toolbar'
  import objectEditor from '@/ui/object-editor'
  import marqueeText from '@/ui/marquee-text'
  // import {getTransform, pinchZoomInit, panInit, validateTransform, getViewport, zoomBy, getScale} from '@lightblue/pinch-zoom';

  export default {
    data: function() {
      return {
        transformMatrix: { scaleX: 1, scaleY: 1 },
        userName: '',
        channelName: '',
        extension: '',
        showMeetingDetails: false,
        copiedMeeting: false,
        copiedExtension: false,
        showParticipants: false,
        users: [],
        userAlert: '',
        loading: true,
        meetingId: '',
        userId: '',
        showMeetingIds: false,
      }
    },
    watch: {
      copiedMeeting (val) {
        if (val) {
          setTimeout(() => this.copiedMeeting = false, 2000)
        }
      },
      copiedExtension (val) {
        if (val) {
          setTimeout(() => this.copiedExtension = false, 2000)
        }
      },
      userAlert (val) {
        if (val) {
          setTimeout(() => this.userAlert = '', 2000)
        }
      },
    },
    mounted: function() {
      const ctx = this.$refs.annotationCanvas.getContext('2d');
      ctx.webkitImageSmoothingEnabled = false;
      ctx.mozImageSmoothingEnabled = false;
      ctx.imageSmoothingEnabled = false;
      let whiteboard = getWhiteboard({canvasId: 'annotation-canvas'});
      whiteboard.on('ready', () => {
        // console.log(whiteboard.getLocalUser(), whiteboard.getTitle())
        this.userName = whiteboard.getLocalUser().user_name
        this.channelName = whiteboard.getTitle();
        this.extension = whiteboard.getExtension();
        this.loading = false
        this.meetingId = sessionStorage.getItem('__MEETINGID__')
        this.userId = sessionStorage.getItem('__LOCALUSER__') 
      })
      var clipboard = new ClipboardJS('.copy-icon');
      this.setTransformMatrix();
      window.addEventListener('resize', this.setTransformMatrix);
      window.addEventListener('orientationchange', this.setTransformMatrix);
      whiteboard.on('userListUpdated', e=> {
        let leavers = this.users.filter(x => !e.users.find(u => u.user_id === x.user_id))
        let joiner = e.users.filter(x => !this.users.find(u => u.user_id === x.user_id))

        if (joiner.length > 0) {
          if (whiteboard.getLocalUser().user_name !== joiner[0].user_name) {
            this.userAlert = `${joiner[0].user_name} has joined`
          }
        }
        if (leavers.length > 0) {
          this.userAlert = `${leavers[0].user_name} has left`
        }
        this.users = JSON.parse(JSON.stringify(e.users))
      });
      whiteboard.on('error', e => {
        let err = {code: e.code, description: e.description };
        this.$router.push({ name: 'error', params: err})
      });
      this.loading = !whiteboard.isReady()
    },
    beforeDestroy: function() {
      window.removeEventListener('resize', this.setTransformMatrix);
      window.removeEventListener('orientationchange', this.setTransformMatrix);
    },
    computed: {
      meetingURL () {
        return `https://call.lifesizecloud.com/${this.extension}`
      },
      style () {
        return {
          backgroundColor: '#fff',
          transform: 'scaleX(' + (this.transformMatrix.scaleX || 1) + ') scaleY(' + (this.transformMatrix.scaleY || 1) + ') translate(-50%,-50%)',
        };
      },
      version () {
        return process.env.VERSION;
      },
      scale () {
        return {
          x: this.transformMatrix.scaleX || 1,
          y: this.transformMatrix.scaleY || 1
        }
      }
    },
    methods: {
      toggleMeetingDetails () {
        this.showMeetingDetails = !this.showMeetingDetails
      },
      setTransformMatrix () {
        let scaleX = this.$refs.outer.offsetWidth / 2560;
        let scaleY = this.$refs.outer.offsetHeight / 1440;
        this.transformMatrix = { scaleX: Math.min(scaleX, scaleY), scaleY: Math.min(scaleX, scaleY) };
      },
    },
    components: {
      lboAnnotationControls,
      objectEditor,
      marqueeText
    }
  }

</script>

<style scoped>
  .version {
    position: absolute;
    right: 5px;
    bottom: 2px;
    color: #ccc;
    font-weight: 100;
    font-family: 'AzoSans-Light';
    font-size: .8rem;
  }
  
  .id-trigger {
    position: absolute;
    left: 0px;
    bottom: 0px;
    color: #ddd;
    display:none
  }

  .meeting-ids { 
    position: absolute;
    left: 25px;
    bottom: 2px;
    color: #ccc;
    font-weight: 100;
    font-family: 'AzoSans-Light';
    font-size: .8rem;
    display: flex;
    flex-direction: column;
    font-family: monospace;
  }
  
  .loading {     
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    height: 100%
  }

  .container {
    display:flex;
    flex-direction: column;
    height: 100vh
  }
  
  .content { 
    flex-grow: 1;
    position: relative;
    background-color: #f0f0f0;
  }

  .info-icon, .copy-icon { 
    width:16px;
    height:16px; 
    margin-left:5px;
    margin-bottom:3px; 
    color: #777;
    cursor:pointer;
  }

  .copy-icon { 
    width:12px;
    height:12px; 
  }
  
  .info-icon:hover, .copy-icon:hover { 
    color: #5650d7
  }
  
  .meeting-name {
    padding-top:1px;
    text-overflow: ellipsis;
    max-width: 50vw;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
  }

  .meeting-details-container {
    position: relative;
    display:flex;
  }

  .meeting-details {
    text-align: left;
    display: block;
    position: absolute;
    z-index: 99;
    top: 46px;
    background: #fff;
    padding: 20px 40px 15px 20px;
    border-radius: 5px;
    box-shadow: 0 3px 20px 0 rgba(0,0,0,.12), 0 -3px 10px 0 rgba(0,0,0,.12);
    font-family: 'AzoSans-Light';
    font-size: .7rem;
    left: -253px;
    line-height: 1.8;
  }

  .meeting-details:after {
    position: absolute;
    content: '';
    top: -15px;
    left: 250px;
    width: 0; 
    height: 0; 
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid #fff;
  }

  .meeting-details > div.title{
    
    font-family: 'AzoSans-Bold'
  }

  .AnnotationPanel {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .watermark-logo-image {
    margin: -32px 0;
    top: 24px;
    right: 16px;
    position: absolute;
    height: 55px;
    opacity: 0.75;
    z-index: 300;
  }

  .transform-container {
    width: 2560px;
    height: 1440px;
    top: 50%;
    left: 50%;
    transform-origin: top left;
    position: absolute;
  }

  textarea[data-fabric-hiddentextarea] {
    position: fixed !important;
  }

  .annotation-info-cell {
    padding: 10px 12px 10px 12px;
    height: 100%;
  }

  .annotation-info-element-received {
    margin: -54px 0 0 0;
    background-color: darkgreen;
    border-radius: 12px 12px 12px 12px;
    position: absolute;
    z-index: 200;
  }

  .annotation-info-private-shared {
    margin: -54px 0 0 0;
    background-color: blue;
    border-radius: 12px 12px 12px 12px;
    position: absolute;
    z-index: 200;
  }

  .annotation-info-user {
    left: 0;
    text-align: left;
    color: yellow;
    margin: 0;
    font-size: 22px;
  }

  .annotation-info-time {
    right: 0;
    text-align: right;
    color: orange;
    margin: 0;
    font-size: 22px;
  }

  .header {
    height: 60px;
    display: flex;
    /* width: 100%; */
    justify-content: center;
    align-items: center;
    box-shadow: 0px 3px 20px 0 rgba(0, 0, 0, .12);
    font-family: AzoSans-Bold;
    z-index: 1;
  }

  
  .footer {
    height: 60px;
    display: flex;
    /* width: 100%; */
    justify-content: center;
    align-items: center;
    box-shadow: 0px -5px 20px 0 rgba(0, 0, 0, .12);
    font-family: AzoSans-Bold;
    z-index: 1;
  }

  .footer:hover .id-trigger {
    display: block
  }

  .username {
    position: absolute;
    left: 23px;
    color: #5650d7;
    padding-top:2px;
  }

  .copyIndicator {
    opacity: 0;
    margin-left:4px;
    transition: opacity .5s linear;
    font-weight: 500
  }

  .visible {
    opacity: 1;
  }

  .participant {
    position: absolute;
    left: 15px;
    top: 15px;
  }

  .participant-list {
    background: #fff;
    padding: 10px;
    margin-top: 7px;
    box-shadow: 0px 3px 20px 0 rgba(0, 0, 0, .12), 0px -3px 10px 0 rgba(0, 0, 0, .12);
    position: relative;
    opacity: .3;
    transition: opacity .5s linear .3s;
    top: 48px;
    left: 15px;
    width: fit-content;
    float: left;
    max-height: 60vh;
    overflow: auto;
  }

  .participant-list:hover {
    opacity: 1;
  }

  .participant-list > ul {
    list-style: none;
    text-align: left;
    margin: 0px;
    padding: 0px;
  }

  .participant-list > ul > li {
    font-size: .7rem;
    display: flex;
    align-items: center;
  }

  .participant-list > ul > li > div:first-child {
    height: 15px;
    width: 15px;
    background: red;
    border-radius: 99px;
    margin-right: 5px;
  }

  .participant-username {
    padding-top:3px
  }

  .participant-button {
    background: #5650d7;
    border-radius: 3px;
    color: white;
    width: fit-content;
    height: 30px;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 3px 20px 1px rgba(0, 0, 0, .12);
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    padding: 0 5px;
  }

  .participant-button > svg {
    margin-right:2px;   
  }

  .participant-button > div {
    padding-top:3px;   
  }

  .participant-notification {
    position: absolute;
    top: 5px;
    left: calc(100% + 12px);

    white-space: nowrap;
    background-color: #5650d7;
    color: white;
    font-size: .8rem;
    padding: 0 4px;
    border-radius: 2px;
    padding-top:3px;
  }

  .participant-notification:before {
    position: absolute;
    content: '';
    top: 3px;
    left: -7px;
    width: 0;
    height: 0;
    border-bottom: 7px solid transparent;
    border-top: 7px solid transparent;
    border-right: 7px solid #5650d7;
  }
</style>
